import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overflow-x-auto" }
const _hoisted_2 = { class: "mb-0 whitespace-nowrap" }
const _hoisted_3 = { class: "text-xs italic text-gray-500 whitespace-nowrap" }
const _hoisted_4 = { class: "mb-0 whitespace-nowrap" }
const _hoisted_5 = { class: "mb-0 break-word" }
const _hoisted_6 = { class: "mb-0 whitespace-nowrap" }
const _hoisted_7 = { class: "mb-0 whitespace-nowrap" }
const _hoisted_8 = { class: "mb-0 break-word" }
const _hoisted_9 = { class: "flex justify-between items-center mt-4" }
const _hoisted_10 = { class: "text-sm text-gray-600" }
const _hoisted_11 = { class: "flex gap-2" }

import { ref, watch, nextTick } from 'vue';
import { usePagination } from '@/core/hooks/use-pagination';
import { useLoading } from '@/core/hooks/use-loading';
import { formatQuantity } from '@/core/helpers/number-format';
import { swalErrNotification, swalNotification } from '@/core/helpers/utils';

interface IVatTuNgoaiDinhMuc {
  id: number;
  ma_vat_tu: string;
  ten_vat_tu: string;
  don_vi: string;
  so_luong: number;
  ghi_chu?: string;
  is_approved: boolean;
}

interface Props {
  items: IVatTuNgoaiDinhMuc[];
  curPage?: number;
  perPage?: number;
}

interface Emits {
  (e: 'approve-selected', items: IVatTuNgoaiDinhMuc[]): void;
}

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'VatTuNgoaiDinhMucTable',
  props: {
    items: {},
    curPage: { default: 1 },
    perPage: { default: 10 }
  },
  emits: ["approve-selected"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

// eslint-disable-next-line no-undef
const emit = __emit;

const { indexCal } = usePagination();
const { startLoading, endLoading } = useLoading();

const vatTuItems = ref<IVatTuNgoaiDinhMuc[]>(props.items);
const selectedItems = ref<IVatTuNgoaiDinhMuc[]>([]);

// Watch for changes in items prop
watch(
  () => props.items,
  (newItems) => {
    vatTuItems.value = newItems;
    // Clear selection when items change
    selectedItems.value = [];
    // Force table to re-render with new data
    nextTick(() => {
      // This ensures the table updates properly after data changes
    });
  },
  { deep: true, immediate: true }
);

const handleSelectionChange = (selection: IVatTuNgoaiDinhMuc[]) => {
  selectedItems.value = selection;
};

const handleApproveSelected = async () => {
  if (selectedItems.value.length === 0) {
    await swalNotification(
      'Vui lòng chọn ít nhất một vật tư để duyệt',
      'warning'
    );
    return;
  }

  try {
    await startLoading();

    // Emit event to parent component
    emit('approve-selected', selectedItems.value);

    await endLoading();
  } catch (error) {
    await endLoading();
    await swalErrNotification(error, 'Có lỗi xảy ra khi duyệt vật tư');
  }
};

// Method to refresh table data
const refreshTableData = () => {
  vatTuItems.value = [...props.items];
  selectedItems.value = [];
};

// Expose refresh method to parent component
__expose({
  refreshTableData,
});

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_table, {
      size: "medium",
      border: true,
      data: vatTuItems.value,
      "empty-text": "Chưa có dữ liệu vật tư ngoài định mức",
      class: "min-w-full",
      onSelectionChange: handleSelectionChange
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "55",
          selectable: (row) => !row.is_approved
        }, null, 8, ["selectable"]),
        _createVNode(_component_el_table_column, {
          label: "STT",
          "min-width": "60",
          "class-name": "text-left"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(indexCal)(scope.$index, _ctx.curPage, _ctx.perPage)), 1),
            _createElementVNode("p", _hoisted_3, [
              _createElementVNode("small", null, "(" + _toDisplayString(scope.row.id) + ")", 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Mã vật tư",
          "min-width": "120",
          "class-name": "text-left"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_4, _toDisplayString(scope.row.ma_vat_tu), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Tên vật tư",
          "min-width": "200",
          "class-name": "text-left"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_5, _toDisplayString(scope.row.ten_vat_tu), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Đơn vị",
          "min-width": "80",
          "class-name": "text-left"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_6, _toDisplayString(scope.row.don_vi), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Số lượng",
          "min-width": "100",
          "class-name": "text-right"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(formatQuantity)(scope.row.so_luong)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Ghi chú",
          "min-width": "150",
          "class-name": "text-left"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_8, _toDisplayString(scope.row.ghi_chu || '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Đã duyệt",
          "min-width": "120",
          "class-name": "text-center"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, {
              type: scope.row.is_approved ? 'success' : 'warning',
              size: "small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row.is_approved ? 'Đã duyệt' : 'Chờ duyệt'), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, " Đã chọn: " + _toDisplayString(selectedItems.value.length) + " / " + _toDisplayString(vatTuItems.value.length) + " vật tư ", 1),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_el_button, {
          type: "primary",
          disabled: selectedItems.value.length === 0,
          onClick: handleApproveSelected
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Duyệt vật tư đã chọn (" + _toDisplayString(selectedItems.value.length) + ") ", 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ])
  ]))
}
}

})